export const GOOGLE_STORE_URL = process.env.NEXT_PUBLIC_GOOGLE_STORE_URL
export const APPLE_STORE_URL = process.env.NEXT_PUBLIC_APPLE_STORE_URL
export const APPLE_STORE_BUSINESS_URL = process.env.NEXT_PUBLIC_APPLE_STORE_BUSINESS_URL || 'https://apps.apple.com/ru/app/yesloyal-for-business/id1550711914'
export const GOOGLE_STORE_BUSINESS_URL = process.env.NEXT_PUBLIC_GOOGLE_STORE_BUSINESS_URL || 'https://play.google.com/store/apps/details?id=com.yesloyal.business'
export const INSTAGRAM_URL = 'https://www.instagram.com/yesloyal/'
export const FACEBOOK_URL = 'https://www.facebook.com/yesloyal/'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/yesloyal/'
